export default __webpack_public_path__ + "media/images/toml_logo-92dcf81b.svg";